import { get,del } from '@/plugins/http'

export default {
  getLawExams: get('/live/api/v1/examination/company'),
  deleteLawExam: del('/live/api/v1/examination/{companyId}'),
  getExamURL: get('/live/api/v1//examination/old/url'),
}
